module.exports = __webpack_public_path__ + "assets/img/PC4.f0229f61.jpg";